import { withInstall } from '@tav-ui/utils/with-install'
import ContainerScroll from './src/container-scroll.vue'
const TaContainerScroll = withInstall(ContainerScroll)
export { TaContainerScroll }
export default TaContainerScroll
export * from './src/types'
